import services from './services';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';
export default {
  mixins: [services],
  data() {
    return {
      DialogVisible: false,
      loading: false,
      isReadOnly: false,
      title: "订单详情",
      form: {},
      SubmitData: this.getSubmitFormData(),
      packages: [{
        ProName: "",
        ProNum: 0
      }],
      BabyInfo: {},
      AgentInfo: {},
      SchoolInfo: {},
      ClassInfo: {},
      ConsigneeList: {},
      RefereeBabyInfo: {},
      RefereeParentInfo: {},
      RefereeBabySchoolInfo: {},
      RefereeBabyAgentInfo: {},
      RefereeBabyClassInfo: {},
      groupNum: 0, //团购数
      isAudit: false, //审核入口
      AuditData: this.getAuditData(),
      status: [{
        "name": "审核通过",
        "id": "6"
      }, {
        "name": "审核不通过",
        "id": "12"
      }],
      PayWayModes: [{
        "name": "私对公打款",
        "id": "1"
      }, {
        "name": "公对公打款",
        "id": "2"
      }],
      AuditShowData: {}
    }
  },
  methods: {
    getSubmitFormData() {
      return cloneDeep({
        "OrderId": 0,
        "OrderStatus": 13,
        "ProList": [{
          "ProId": 0,
          "ProNum": 0
        }]

      });
    },
    getAuditData() {
      return cloneDeep({
        "OrderId": 0,
        "AuditRemark": "",
        "OrderStatus": '',
        Payer: '',
        VoucherMoney: '',
        PreReceiveCode: '',
        PayWayMode: ''
      })
    },
    initData() {
      this.form = {}
      this.BabyInfo = {}
      this.AgentInfo = {}
      this.SchoolInfo = {}
      this.ClassInfo = {}
      this.ConsigneeList = {}
    },
    LookPicture(Url) {
      viewPhoto.show({
        showImgId: "", //指定id显示图片
        thumbList: [{
          src: Url,
          id: ""
        }]
      });
    },
    show(opts) {
      this.AuditData = this.getAuditData()
      this.DialogVisible = true
      this.initData()
      this.title = opts.title
      this.isReadOnly = opts.isReadOnly
      this.getById(opts.OrderId)
      this.SubmitData.OrderId = opts.OrderId
      if (opts.PackageId) {
        this.getDetailsPackage(opts.PackageId)
      }
      if (this.title == '审核') {
        this.isAudit = true
        this.AuditData.OrderId = opts.OrderId
      } else {
        this.isAudit = false
      }

    },
    dialogClose() {
      // 查看关闭
      this.DialogVisible = false
    },
    // 审核提交
    AuditSubmit() {
      if (this.AuditData.OrderStatus == '') {
        this.$notify({
          title: '警告',
          message: '请选择审核意见',
          type: 'warning'
        });
        return;
      }
      if (this.AuditData.OrderStatus == 12 && this.AuditData.AuditRemark == '') {
        this.AuditData.PayWayMode = ""
        this.AuditData.Payer = ""
        this.AuditData.VoucherMoney = ""
        this.AuditData.PreReceiveCode = ""
        this.$notify({
          title: '警告',
          message: '请填写审核备注',
          type: 'warning'
        });
        return;
      }
      var rules = []
      if (this.AuditData.OrderStatus == 6) {
        rules.push({
          name: "打款方式",
          value: this.AuditData.PayWayMode,
          required: true,
        }, {
          name: "凭证金额",
          value: this.AuditData.VoucherMoney,
          required: true,
          more0: true,
        }, {
          name: "预收单",
          value: this.AuditData.PreReceiveCode,
          required: true
        })
        if (this.AuditData.PayWayMode == 1) {
          rules.push({
            name: "打款人",
            value: this.AuditData.Payer,
            required: true,
          })
        } else {
          this.AuditData.Payer = ''
        }
      }

      var flag = util.checkForm({
        ele: this,
        rules: rules
      });
      if (!flag) {
        return;
      }
      this.UserOrderAuditForFinance()
    },
    submit() {
      // 审核提交
      //totalNum只能等于4
      let totalNum = 0;
      let packagesList = []
      for (let i = 0; i < this.packages.length; i++) {
        if (this.packages[i].ProNum > 0) {
          packagesList.push(this.packages[i])
        }
        totalNum += this.packages[i].ProNum;

      }
      //console.log(packagesList)
      if (totalNum < 4) {
        this.$notify({
          title: '警告',
          message: '配置资源数少于4',
          type: 'warning'
        });
      } else if (totalNum > 4) {
        this.$notify({
          title: '警告',
          message: '配置资源数大于4',
          type: 'warning'
        });
      } else {
        this.SubmitData.ProList = packagesList
        this.ConfigOrderResource()
      }


    }
  },

}


// WEBPACK FOOTER //
// ./src/pages/Family/OrderList/viewDialog/vm.js